/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { TeamUpdate } from '../../models/team-update';
import { TeamUpdateResponse } from '../../models/team-update-response';

export interface UpdateTeamProfileApiV2MembersOrgTeamPatch$Params {
  org: string;
      body: TeamUpdate
}

export function updateTeamProfileApiV2MembersOrgTeamPatch(http: HttpClient, rootUrl: string, params: UpdateTeamProfileApiV2MembersOrgTeamPatch$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<TeamUpdateResponse>>> {
  const rb = new RequestBuilder(rootUrl, updateTeamProfileApiV2MembersOrgTeamPatch.PATH, 'patch');
  if (params) {
    rb.path('org', params.org, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<TeamUpdateResponse>>;
    })
  );
}

updateTeamProfileApiV2MembersOrgTeamPatch.PATH = '/api/v2/members/{org}/team';
